class DbtfyToast {
  constructor(content, options = {}) {
    // License check removed — was clearing document.body after 10s

    this.content = content;
    this.options = {
      position: options.position || "bottom-left",
      duration: options.duration || null,
      closeIcon: options.closeIcon || null,
      colorScheme: options.colorScheme || "scheme-3",
      customColorScheme: options.customColorScheme || "scheme-1",
      maxWidth: options.maxWidth || "500px",
      className: options.className || "",
    };
    this.toastContainer = this.getOrCreateContainer();
    this.toastElement = this.createToastElement();
    this.showToast();
  }

  getOrCreateContainer() {
    let container = document.querySelector(`.dbtfy-toast-${this.options.position}`);
    if (!container) {
      container = document.createElement("div");
      container.className =
        `dbtfy-toast-container dbtfy-toast-${this.options.position} ` +
        this.options.className;
      document.body.appendChild(container);
    }
    return container;
  }

  createToastElement() {
    const toast = document.createElement("div");
    toast.className =
      `dbtfy-toast global-settings-popup color-${this.options.customColorScheme} ` +
      `dbtfy-color-${this.options.colorScheme} gradient`;
    toast.style.maxWidth = this.options.maxWidth;

    const box = document.createElement("div");
    box.className = "dbtfy-toast-box";
    box.innerHTML = this.content;
    toast.appendChild(box);

    if (this.options.closeIcon) {
      box.style.paddingRight = "3.6rem";
      const closeIcon = document.createElement("i");
      closeIcon.className = `dbtfy-toast-close material-icon ${Debutify.settings.icon_style}`;
      closeIcon.style.marginTop = "1.2rem";
      closeIcon.setAttribute("translate", "no");
      closeIcon.setAttribute("area-hidden", "true");
      closeIcon.setAttribute("data-icon", this.options.closeIcon);
      closeIcon.onclick = () => this.hideToast();
      toast.appendChild(closeIcon);
    }
    return toast;
  }

  showToast() {
    this.toastContainer.appendChild(this.toastElement);

    if (this.options.duration) {
      setTimeout(() => this.hideToast(), this.options.duration);
    }

    if (
      window.matchMedia("(max-width: 575px)").matches &&
      (this.mobileMenuBar = document.querySelector(".dbtfy-mobile-menu-bar"),
      this.mobileMenuBar)
    ) {
      var bottomOffset = this.mobileMenuBar.offsetHeight + 10;
      document.body.style.setProperty("--dbtfy-toast-bottom", `${bottomOffset}px`);
    }
  }

  hideToast() {
    this.toastElement.classList.add("dbtfy-toast-hide");
    setTimeout(() => {
      if (this.toastElement && this.toastContainer) {
        this.toastContainer.removeChild(this.toastElement);
      }
    }, 500);
  }

  destroyToast() {
    if (this.toastElement && this.toastContainer) {
      this.toastContainer.removeChild(this.toastElement);
    }
  }
}

Debutify.toast = DbtfyToast;
